/*!
 * mini-parallax v0.3.3
 * https://github.com/ko-yelie/mini-parallax#readme
 *
 * @license
 * Copyright (c) 2018 Ko.Yelie
 * Released under the MIT License.
 */
function noop() {}
/**
 * Convert NodeList to array
 *
 * @param {NodeList} nodeList NodeList
 * @return {NodeList[]} array of NodeList
 */

function convertIntoArray(nodeList) {
  return nodeList ? Array.prototype.slice.call(nodeList, 0) : [];
}
/**
 * Get elements that can use forEach
 *
 * @param {string|NodeList|Element|Element[]} target - selector or elements
 * @param {Element} context - context element
 * @return {Element[]} array of elements
 */


function getElements(target, context) {
  if ( context === void 0 ) context = document;

  if (typeof target === 'string') {
    // string
    var nodeList = context.querySelectorAll(target);
    return convertIntoArray(nodeList);
  } else if (target.length) {
    if (target.map) {
      // Array
      return target;
    } else {
      // NodeList
      return convertIntoArray(target);
    }
  } else {
    // Element
    return [target];
  }
}

/**
 * Parallax library
 */

var NormalParallax = function NormalParallax(target, options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  this._els = getElements(target);

  if (this._els.length === 0) {
    this._disabled = true;
    return;
  }

  var speed = options.speed; if ( speed === void 0 ) speed = 0.1;
  var speedSp = options.speedSp; if ( speedSp === void 0 ) speedSp = speed;
  var isSP = options.isSP; if ( isSP === void 0 ) isSP = noop;
  var onResize = options.onResize; if ( onResize === void 0 ) onResize = noop;
  var onScroll = options.onScroll; if ( onScroll === void 0 ) onScroll = noop;
  var isRound = options.isRound; if ( isRound === void 0 ) isRound = false;
  var autoRun = options.autoRun; if ( autoRun === void 0 ) autoRun = true;
  this._optionOnResize = onResize;
  this._optionOnScroll = onScroll;
  this._fTansform = "_getTransform" + (isRound ? 'Round' : '');
  this._scrollTarget = document.scrollingElement || document.documentElement;
  this._speedPc = speed;
  this._speedSp = speedSp;
  this._isSP = isSP;

  this._onResize = function () {
    this$1.update();

    this$1._optionOnResize(this$1._windowHeight);
  };

  window.addEventListener('resize', this._onResize);

  this._onLoad = function () {
    this$1.update();
  };

  window.addEventListener('load', this._onLoad);
  autoRun && this.run();
};
/**
 * Cache various values
 */


NormalParallax.prototype._cache = function _cache () {
    var this$1 = this;

  this._isSpCurrent = this._isSP();
  this._speed = this._isSpCurrent ? this._speedSp : this._speedPc;
  this._speed *= window.innerWidth / window.innerHeight;
  this._windowHeight = window.innerHeight;
  var scrollY = window.scrollY || window.pageYOffset;
  this._items = this._els.map(function (el) {
    el.style.transform = 'none';
    var willChange = window.getComputedStyle(el).willChange;
    el.style.willChange = 'transform';
    if (!(willChange === 'auto' || willChange === 'transform')) { el.style.willChange += ', ' + willChange; }
    return this$1._cacheElementPos(el, scrollY);
  }).filter(function (item) { return item; });
};
/**
 * Each frame of animation
 */


NormalParallax.prototype._tick = function _tick () {
    var this$1 = this;

  var scrollTop = this._scrollTarget.scrollTop;

  if (scrollTop !== this._scrollTop) {
    // When the scroll position changes
    this._scrollTop = scrollTop;

    this._update();
  }

  this._animationFrameId = requestAnimationFrame(function () {
    this$1._tick();
  });
};
/**
 * Update the position of each element
 */


NormalParallax.prototype._update = function _update () {
    var this$1 = this;

  this._centerViewport = this._scrollTop + this._windowHeight / 2;

  this._items.forEach(function (item) { return this$1._updateElement(item); });

  this._optionOnScroll(this._scrollTop);
};
/**
 * Return the value of transform
 */


NormalParallax.prototype._getTransform = function _getTransform (position) {
  return ("translate3d(0, " + position + "px, 0)");
};
/**
 * Return the value of transform
 * In order to avoid problems such as bleeding, convert the number to an integers
 */


NormalParallax.prototype._getTransformRound = function _getTransformRound (position) {
  return ("translate3d(0, " + (Math.round(position)) + "px, 0)");
};
/**
 * Cache various values of one element
 */


NormalParallax.prototype._cacheElementPos = function _cacheElementPos (el, scrollY) {
  // Do not parallax if it is specified to invalidate by SP
  if (this._isSpCurrent && el.dataset.sp === 'false') { return; }
  var bounding = el.getBoundingClientRect();
  var top = bounding.top + scrollY;
  return {
    el: el,
    top: top,
    center: top + bounding.height / 2,
    speed: parseFloat(el.dataset.speed, 10) || this._speed,
    inPos: top - this._windowHeight,
    outPos: bounding.bottom + scrollY
  };
};
/**
 * Update the position of one element
 */


NormalParallax.prototype._updateElement = function _updateElement (item) {
  if (this._scrollTop > item.outPos) ; else if (this._scrollTop > item.inPos) {
    // After the element can be seen from below
    var position = (item.center - this._centerViewport) * item.speed;
    item.el.style.transform = this[this._fTansform](position);
  }
};
/**
 * Run animation
 */


NormalParallax.prototype.run = function run () {
    var this$1 = this;

  if (this._disabled) { return; }

  this._cache();

  this._animationFrameId = requestAnimationFrame(function () {
    this$1._tick();
  });
};
/**
 * Update cache and position
 */


NormalParallax.prototype.update = function update () {
  if (this._disabled) { return; }

  this._cache();

  this._update();
};
/**
 * Destroy instance
 */


NormalParallax.prototype.destroy = function destroy () {
  if (!this._els) { return; }
  cancelAnimationFrame(this._animationFrameId);

  this._els.forEach(function (el) {
    el.style.transform = null;
    el.style.willChange = null;
  });

  window.removeEventListener('resize', this._onResize);
  window.removeEventListener('load', this._onLoad);
};
/**
 * @typedef {function} onResize
 * @param {number} windowHeight - `window.innerHeight`
 */

/**
 * @typedef {function} onScroll
 * @param {number} scrollTop - `document.scrollingElement.scrollTop`
 */

/**
 * Automatically calculate the moving distance from the height of the parent element
 */

var BackgroundParallax = function BackgroundParallax(target, options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  this._els = getElements(target);

  if (this._els.length === 0) {
    this._disabled = true;
    return;
  }

  var onResize = options.onResize; if ( onResize === void 0 ) onResize = noop;
  var onScroll = options.onScroll; if ( onScroll === void 0 ) onScroll = noop;
  var isRound = options.isRound; if ( isRound === void 0 ) isRound = false;
  var autoRun = options.autoRun; if ( autoRun === void 0 ) autoRun = true;
  this._optionOnResize = onResize;
  this._optionOnScroll = onScroll;
  this._fTansform = "_getTransform" + (isRound ? 'Round' : '');
  this._scrollTarget = document.scrollingElement || document.documentElement;

  this._onResize = function () {
    this$1.update();

    this$1._optionOnResize(this$1._windowHeight);
  };

  window.addEventListener('resize', this._onResize);

  this._onLoad = function () {
    this$1.update();
  };

  window.addEventListener('load', this._onLoad);
  autoRun && this.run();
};
/**
 * Cache various values
 */


BackgroundParallax.prototype._cache = function _cache () {
    var this$1 = this;

  this._windowHeight = window.innerHeight;
  var scrollY = window.scrollY || window.pageYOffset;
  this._items = this._els.map(function (el) {
    el.style.transform = 'none';
    var willChange = window.getComputedStyle(el).willChange;
    el.style.willChange = 'transform';
    if (!(willChange === 'auto' || willChange === 'transform')) { el.style.willChange += ', ' + willChange; }
    return this$1._cacheElementPos(el, scrollY);
  }).filter(function (item) { return item; });
};
/**
 * Each frame of animation
 */


BackgroundParallax.prototype._tick = function _tick () {
    var this$1 = this;

  var scrollTop = this._scrollTarget.scrollTop;

  if (scrollTop !== this._scrollTop) {
    // When the scroll position changes
    this._scrollTop = scrollTop;

    this._update();
  }

  this._animationFrameId = requestAnimationFrame(function () {
    this$1._tick();
  });
};
/**
 * Update the position of each element
 */


BackgroundParallax.prototype._update = function _update () {
    var this$1 = this;

  this._items.forEach(function (item) { return this$1._updateElement(item); });

  this._optionOnScroll(this._scrollTop);
};
/**
 * Return the value of transform
 */


BackgroundParallax.prototype._getTransform = function _getTransform (position) {
  return ("translate3d(0, " + position + "px, 0)");
};
/**
 * Return the value of transform
 * In order to avoid problems such as bleeding, convert the number to an integers
 */


BackgroundParallax.prototype._getTransformRound = function _getTransformRound (position) {
  return ("translate3d(0, " + (Math.round(position)) + "px, 0)");
};
/**
 * Cache various values of one element
 */


BackgroundParallax.prototype._cacheElementPos = function _cacheElementPos (el, scrollY) {
  var bounding = el.getBoundingClientRect();
  var boundingParent = el.parentNode.getBoundingClientRect();
  var top = boundingParent.top + scrollY;
  var inPos = top - this._windowHeight;
  var outPos = boundingParent.bottom + scrollY;
  return {
    el: el,
    max: boundingParent.height - bounding.height,
    inPos: inPos,
    outPos: outPos,
    distance: outPos - inPos,
    offset: boundingParent.top - bounding.top
  };
};
/**
 * Update the position of one element
 */


BackgroundParallax.prototype._updateElement = function _updateElement (item) {
  if (this._scrollTop > item.outPos) ; else {
    var diff = this._scrollTop - item.inPos;

    if (diff > 0) {
      // After the element can be seen from below
      var rate = diff / item.distance;
      var position = item.offset + item.max - item.max * rate; // max - (max - min) * rate

      item.el.style.transform = this[this._fTansform](position);
    }
  }
};
/**
 * Run animation
 */


BackgroundParallax.prototype.run = function run () {
    var this$1 = this;

  if (this._disabled) { return; }

  this._cache();

  this._animationFrameId = requestAnimationFrame(function () {
    this$1._tick();
  });
};
/**
 * Update cache and position
 */


BackgroundParallax.prototype.update = function update () {
  if (this._disabled) { return; }

  this._cache();

  this._update();
};
/**
 * Destroy instance
 */


BackgroundParallax.prototype.destroy = function destroy () {
  if (!this._els) { return; }
  cancelAnimationFrame(this._animationFrameId);

  this._els.forEach(function (el) {
    el.style.transform = null;
    el.style.willChange = null;
  });

  window.removeEventListener('resize', this._onResize);
  window.removeEventListener('load', this._onLoad);
};
/**
 * @typedef {function} onResize
 * @param {number} windowHeight - `window.innerHeight`
 */

/**
 * @typedef {function} onScroll
 * @param {number} scrollTop - `document.scrollingElement.scrollTop`
 */

export { BackgroundParallax, NormalParallax };
